import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { Role } from 'src/features/roles/utils/types';
import { RoleFormSchemaValues } from 'src/features/roles/utils/formSchema';

const RESOURCE = '/:parkingId/role/:roleId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    data: RoleFormSchemaValues;
    roleId: string;
    parkingId: string;
}
const mutationFn = ({ roleId, parkingId, data }: DTO): Promise<Role> => {
    return axios.patch(formatResourcePath(RESOURCE, { roleId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateRole };
